module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<%#- JSON.stringify(resourceData); %>\n<div class=\"row\">\n<div class=\"col\">StatusCode:</div>\n<div class=\"col\"><%= resourceData._statusCode || resourceData.statusCode; %></div>\n</div>\n<div class=\"row\">\n<div class=\"col\">Name:</div>\n<div class=\"col\"><%= resourceData.name; %></div>\n</div>\n<div class=\"row\">\n<div class=\"col\">ErrorCode:</div>\n<div class=\"col\"><%= resourceData.errorCode; %></div>\n</div>\n<div class=\"row\">\n<div class=\"col\">Message:</div>\n<div class=\"col\"><%= resourceData.message; %></div>\n</div>\n<div class=\"row\">\n<div class=\"col\">Detail:</div>\n<div class=\"col\"><%- (resourceData.detail || '').replace(/\\n/g, '<br>'); %></div>\n</div>\n<% utils.forEach(resourceData.childErrors || [], function(error){ %>\n<%- include('./errorDisplay', { resourceData: error }); %>\n<% }); %>\n</div>"
  , __filename = "..\\..\\npm\\frontend-controller\\baseComponents\\error\\errorDisplay.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n")
    ; __line = 2
    ; __append("\n<div class=\"row\">\n<div class=\"col\">StatusCode:</div>\n<div class=\"col\">")
    ; __line = 5
    ; __append(escapeFn( resourceData._statusCode || resourceData.statusCode ))
    ; __append("</div>\n</div>\n<div class=\"row\">\n<div class=\"col\">Name:</div>\n<div class=\"col\">")
    ; __line = 9
    ; __append(escapeFn( resourceData.name ))
    ; __append("</div>\n</div>\n<div class=\"row\">\n<div class=\"col\">ErrorCode:</div>\n<div class=\"col\">")
    ; __line = 13
    ; __append(escapeFn( resourceData.errorCode ))
    ; __append("</div>\n</div>\n<div class=\"row\">\n<div class=\"col\">Message:</div>\n<div class=\"col\">")
    ; __line = 17
    ; __append(escapeFn( resourceData.message ))
    ; __append("</div>\n</div>\n<div class=\"row\">\n<div class=\"col\">Detail:</div>\n<div class=\"col\">")
    ; __line = 21
    ; __append( (resourceData.detail || '').replace(/\n/g, '<br>') )
    ; __append("</div>\n</div>\n")
    ; __line = 23
    ;  utils.forEach(resourceData.childErrors || [], function(error){ 
    ; __append("\n")
    ; __line = 24
    ; __append( include('./errorDisplay', { resourceData: error }) )
    ; __append("\n")
    ; __line = 25
    ;  }); 
    ; __append("\n</div>")
    ; __line = 26
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\..\npm\frontend-controller\baseComponents\error\errorDisplay.ejs

}